/**
 *   域名管理
 */

 const ipAddress = {
    //测试
    qi:'http://shine.qiouou.com:9002',
   // qi:'http://192.168.101.107:9002',
  // qi:'http://192.168.101.135:9002'
 // qi:'http://127.0.0.1:9000'
}
export default ipAddress;



// WEBPACK FOOTER //
// ./src/axios/ipAddress.js